import { Base } from "../core/base.model";

export class Prioridad extends Base{
    id: number;
    nombre: String;
    tiempo_en_horas: number;
}
